import React from "react";
import ReactDOM from "react-dom/client";
import theme from "./theme/muiTheme";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, responsiveFontSizes } from "@mui/material";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

const responsiveTheme = responsiveFontSizes(theme);
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <ThemeProvider theme={responsiveTheme}>
      <App />
    </ThemeProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
